import {Card} from 'antd';
import React, {useState, Key} from 'react';

import {CustomTabs} from 'components/custom-tabs';
import {
    GroupCompanyProtocolTab
} from 'pages/ais/organization-structure-v5/ui/tabs/group-company-protocol';

import {TABS_KEYS, TABS_TITLES, TAB_HEADERS} from '../../model/constants';
import {GroupCompanyInfoTab} from '../tabs/group-company-info-tab';
import {OrgInfoTab} from '../tabs/org-info-tab';
import {SubmitGroupCompanyTab} from '../tabs/submit-company-group-tab';
import styles from './page.module.less';

export const Page = () => {
    const [selectedTabKey, setSelectedTabKey] = useState<Key>(TABS_KEYS.orgInfo);

    return (
        <Card
            title="Сценарий 11. Сведения по структуре группы компаний (v5)"
            className={styles['organization-structure__card']}
        >
            <CustomTabs
                selectedTabKey={selectedTabKey}
                setSelectedTabKey={setSelectedTabKey}
                tabs={[
                    {
                        key: TABS_KEYS.orgInfo,
                        title: TABS_TITLES.orgInfo,
                        content: <OrgInfoTab />
                    },
                    {
                        key: TABS_KEYS.groupCompanyInfo,
                        title: TABS_TITLES.groupCompanyInfo,
                        content: <GroupCompanyInfoTab />,
                    },
                    {
                        key: TABS_KEYS.groupCompanyProtocol,
                        title: TABS_TITLES.groupCompanyProtocol,
                        content: <GroupCompanyProtocolTab />,
                    },
                    {
                        key: TABS_KEYS.submitGroupCompany,
                        title: TABS_TITLES.submitGroupCompany,
                        content: <SubmitGroupCompanyTab />,
                        header: TAB_HEADERS.submitGroupCompanyHeader
                    },
                ]}
            />
        </Card>
    );
};
